import { Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const styles = {
  root: {
    textTransform: 'initial',
    borderRadius: '16px',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: 'bold',
    '& svg': {
      marginRight: '16px',
    },
    minHeight: '48px',
    lineHeight: '24px',
    margin: '0 8px',
    minWidth: '120px',

    '&.small': {
      minWidth: '8rem',
      padding: '6px 14px',
      borderRadius: '12px',
    },
  },
};

const primaryStyles = () => {
  return {
    root: {
      ...styles.root,
      background: '#00A680',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#00A680',
      },
    },
  };
};

export const PrimaryButton = withStyles(primaryStyles)((props) => {
  const { className, ...rest } = props;
  const classes = props.classes || {};
  return (
    <Button
      {...rest}
      className={`${className} ${classes.root}`}
      variant="contained"
      size="large"
    />
  );
});

const secondaryStyles = () => {
  return {
    root: {
      ...styles.root,
      background: '#3B7CFF',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#3B7CFF',
      },
    },
  };
};

export const SecondaryButton = withStyles(secondaryStyles)((props) => {
  const { className, ...rest } = props;
  const classes = props.classes || {};
  return (
    <Button
      {...rest}
      className={`${className} ${classes.root}`}
      variant="contained"
      size="large"
    />
  );
});

const greyButtonStyles = () => {
  return {
    root: {
      ...styles.root,
      background: '#DBDBDB',
      color: '#000000',
      '&:hover': {
        backgroundColor: '#DBDBDB',
      },
    },
  };
};

export const GreyButton = withStyles(greyButtonStyles)((props) => {
  const { className, ...rest } = props;
  const classes = props.classes || {};
  return (
    <Button
      {...rest}
      className={`${classes.root} ${className}`}
      variant="contained"
      size="large"
    />
  );
});

const deleteStyles = () => {
  return {
    root: {
      ...styles.root,
      background: '#FF585B',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#FF585B',
      },
    },
  };
};

export const DeleteButton = withStyles(deleteStyles)((props) => {
  const { className, ...rest } = props;
  const classes = props.classes || {};
  return (
    <Button
      {...rest}
      className={`${className} ${classes.root}`}
      variant="contained"
      size="large"
    />
  );
});

export const createRipple = (event) =>{
  try {
    const button = event.blob;
    const circle = document.createElement("span");
    // const diameter = Math.max(button.clientWidth, button.clientHeight);
    const diameter = button.clientHeight
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.offsetX - radius}px`;
    circle.style.top = `${event.offsetY - radius}px`;
    circle.classList.add("ripple");

    const ripple = button.getElementsByClassName("ripple")[0];

    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  } catch (error) {
    console.warn(error);
  }
}
